<template>
  <div class="cart-header">
    <div class="cart-title-wrapper">
      <icon-base width="25" height="25" class="cart-title-icon" :iconName="'Cart'">
        <icon-bag />
      </icon-base>
      <div class="cart-title" v-if="showStaffCartInfo" tabindex="0" :aria-label="`Order For: ${firstNameShow} ${lastNameShow}`">
        Order For: {{ firstNameShow }} {{ lastNameShow }}
        <span v-if="showPhone"><br />{{ showPhone }}</span>
      </div>
      <div v-else class="cart-title" tabindex="0" aria-label="My Order">My Order</div>
      <i v-if="showSpinner" class="fas fa-spinner fa-spin loading-spinner"></i>
    </div>
    <button id="close-cart" type="button" class="cart-close-button" @click="closeCart">
      <span class="screen-reader">Close Cart</span>
      <div class="icon-close">
        <div class="icon-close-inner"></div>
      </div>
    </button>
  </div>
</template>

<script>
import IconBase from '../IconBase.vue'
import IconBag from '../icons/IconBag.vue'

export default {
  name: 'CartHeader',
  components: {
    IconBase,
    IconBag,
  },
  props: {
    showSpinner: { type: Boolean },
    showStaffCartInfo: { type: Boolean, default: false },
    showPhone: { type: String },
    firstNameShow: { type: String },
    lastNameShow: { type: String },
  },
  methods: {
    closeCart() {
      this.$emit('close-cart')
    },
  },
}
</script>

<style scoped>
.loading-spinner {
  margin-left: 10px;
  font-size: 20px;
}
</style>

<style lang="scss" scoped>
.cart-header {
  background-color: $royal;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  padding: 11px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cart-title-wrapper {
  display: flex;
  align-items: center;
  color: $white;
}

.cart-title-icon {
  color: $white;
  margin-right: 5px;
}

.cart-title {
  font-size: 1.5rem;
  font-weight: 700;
}

.screen-reader {
  @include screen-reader-text;
}

.cart-close-button {
  @include transition(color);
  display: block;
  color: $white;

  &:hover,
  &:focus {
    color: $gold;
  }
}

.icon-close {
  display: block;
  height: 22px;
  width: 22px;
  border: 1px solid currentColor;
  position: relative;
}

.icon-close-inner {
  &::before,
  &::after {
    content: '';
    display: block;
    background-color: currentColor;
    width: 1px;
    height: 27px;
    position: absolute;
    top: 0;
    left: 50%;
  }

  &::before {
    transform: translate(-50%, -3px) rotate(45deg);
  }

  &::after {
    transform: translate(-50%, -3px) rotate(-45deg);
  }
}
</style>
